/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Baranchikov
 * @version 1.27.0
 * @since 1.15.0
 */

import { API_ORDER_ID_FILE_DOWNLOAD } from '../../../modules/app/Api';
import { AccessComponentKeyEnum } from '../../../modules/role/constants/guard/guardConstants';
import { guardComponentType } from '../../../modules/role/reducer/guardReducer';
import { ExternalRoutePath } from '../../../routes/constants/externalRoutes';
import { ROUTE_ORDER_ID, RoutePath } from '../../../routes/constants/routesConstants';
import { stringFormat, stringFormatParams } from '../../../utils/stringFormat';

export const getPageOrderIdUrl = (guardTypes: guardComponentType, id: number | string) =>
    guardTypes[AccessComponentKeyEnum.PageOrderId]
        ? RoutePath.orderId.replace(ROUTE_ORDER_ID, String(id))
        : stringFormat(ExternalRoutePath.order, id);

export const getPageOrderIdUrlRegex = (guardTypes: guardComponentType) =>
    guardTypes[AccessComponentKeyEnum.PageOrderId] ? RoutePath.orderId : ExternalRoutePath.order;

export const isPageOrderIdExternalUrl = (guardTypes: guardComponentType) =>
    !guardTypes[AccessComponentKeyEnum.PageOrderId];

export const getPageOrderIdFileUrl = (guardTypes: guardComponentType, id: string, fileId: string) =>
    guardTypes[AccessComponentKeyEnum.PageOrderId]
        ? stringFormatParams(API_ORDER_ID_FILE_DOWNLOAD, { orderId: id, fileId })
        : `${getPageOrderIdUrl(guardTypes, id)}/${fileId}`;
